import React, { useEffect, useState } from "react";
import logo from "../../assets/logo.png";
import colorIcon from "../../assets/color_icon.svg";
import userIcon from "../../assets/user.svg";
import artistImage from "../../assets/artist_image.svg";
import homeImage from "../../assets/home_image.svg";
import { NavLink } from "react-router-dom";
import { getAuthUser } from "../../utils/GetAuthUser";
import requestContestIcon from "../../assets/contest_request_icon.svg";
import dollerIcon from "../../assets/dollar_icon.svg";

export const ArtistSidebar = () => {
  const [isReffrelArtist, setIsReffrelArtist] = useState(false);
  const authUser = getAuthUser();
  const createdStatusCode = 140;

  useEffect(() => {
    if (authUser?.user?.referral_code > 0) {
      setIsReffrelArtist(true);
    } else {
      setIsReffrelArtist(false);
    }
  }, [authUser]);

  // Common items (always visible)
  const commonItems = [
    { path: "/artist", label: "Home", icon: homeImage },
    { path: "/artist/artist-list", label: "Artists", icon: artistImage },
    { path: `/artist/profile/${authUser.userId}`, label: "Profile Details", icon: userIcon },

  ];

  // Conditional items based on referral artist
  const referralItems = isReffrelArtist
    ? [
      { path: "/artist/user-requests", label: "User Requests", icon: requestContestIcon },
      { path: "/artist/your-contest", label: "Your Contests", icon: colorIcon },
    { path: `/artist/my-earnings/${authUser.userId}`, label: "Event Earnings", icon: dollerIcon },




    ]
    : [
        { path: "/artist/user-requests", label: "User Requests", icon: requestContestIcon },
        { path: `/artist/contests/${createdStatusCode}`, label: "All Contests", icon: colorIcon },
        { path: "/artist/my-rewards", label: "My Rewards", icon: dollerIcon },
        { path: `/artist/my-earnings/${authUser.userId}`, label: "My Earnings", icon: dollerIcon },
      ];

  const menuItems = [...commonItems.slice(0, 1), ...referralItems, ...commonItems.slice(1)];

  return (
    <div className="relative w-full h-full flex flex-col items-center">
      {/* Logo */}
      <div className="flex items-center justify-center">
        <div className="w-[70px] h-[71px]">
          <img
            src={logo}
            alt="Loading"
            className="w-full h-full object-contain"
          />
        </div>
      </div>

      {/* Navigation Part */}
      <div className="pt-7 px-7 w-full flex items-center justify-center">
        <ul className="flex flex-col">
          {menuItems.map((item) => (
            <li key={item.path} className="relative mb-[6px]">
              <NavLink
                to={item.path}
                end={item.path === "/user" || item.path === "/artist" || item.path === "/admin"}
                className={({ isActive }) =>
                  `px-[19px] py-3 flex items-center justify-start gap-2 outline-none  rounded-[10px] ${
                    isActive
                      ? "text-white font-bold bg-primary"
                      : "text-black hover:bg-primary hover:text-white"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    {isActive && (
                      <span className="absolute -left-3 top-1/2 transform -translate-y-1/2 h-5 w-[3px] bg-primary rounded-r-md"></span>
                    )}
                    <img src={item.icon} alt="icon" className="w-5 h-5" />
                    <span className="font-medium text-sm font-grotesk whitespace-nowrap">
                      {item.label}
                    </span>
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
